export default "__VITE_ASSET__KDgairRu__"